import { Tab, Tabs } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { OptionsTabsProps as Props } from './types';

export const OptionsTabs = memo(({ className }: Props) => {
  const [selectedTab] = useState(0);

  return (
    <Styled.Wrapper
      className={classnames('OptionsTabs', className)}
      sx={SX.root}
    >
      <Tabs
        value={selectedTab}
        onChange={() => {}}
        aria-label="options tabs"
        variant="fullWidth"
      >
        <Tab label="All" />
        <Tab label="Mine" />
        <Tab label="Shared" />
      </Tabs>
    </Styled.Wrapper>
  );
});

OptionsTabs.displayName = 'OptionsTabs';
